export default __webpack_public_path__ + "static/media/Scarhide Boots.6692f748.jpg";